module.exports = __webpack_public_path__ + "img/u3015.37271bba.jpg";